import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import RippleLoader from "../../../components/loader/RippleLoader";
import { Form, Formik } from "formik";
import ConfirmationModel from "../../../components/common/ConfirmationModel";
import { companiesStaff, createManager, getByIdOutlet } from "../../../redux/companies/slice";
import { useDispatch, useSelector } from "react-redux";
import { SelectWithLabel } from "../../../components/micro/input";
import { Chip } from "@mui/material";
import { Cancel } from "@mui/icons-material";

const AddEditManager = ({ onClose, companyId, managerData, modalData }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [managerOptions, setOutletOptions] = useState([]);

  //Selector
  const { managerList } = useSelector((store) => ({
    managerList: store?.companiesData?.companiesStaffStatus?.data,
  }));

  useEffect(() => {
    dispatch(
      companiesStaff({
        search: "",
        roles: "manager",
        pageCount: "",
        pageLimit: "all",
        types: "Outlet",
        outlet: "",
        company_id: companyId || "",
        sort_by: "",
        sort_direction: "desc",
      })
    );
  }, []);

  useEffect(() => {
    if (companyId) {
      const filteredOutlets = Array?.isArray(managerList?.data)
        ? managerList?.data
            .filter((outlet) => outlet.company_id === companyId)
            .map((outlet) => ({
              value: outlet.user_id,
              label: outlet.user.full_name,
            }))
        : [];
      setOutletOptions(filteredOutlets);
    }
  }, [managerList]);

  const handleFormSubmit = async (values) => {
    const payload = {
      outlet_id: modalData?.id,
      manager_ids: values?.manager?.map((manager) => manager.value),
    };

    setIsLoading(true);
    dispatch(createManager(payload))
      .then((res) => {
        if (res.type === "createManager/fulfilled") {
          onClose();
          dispatch(getByIdOutlet(modalData?.id));
        }
        setShowConfirmationModal(false);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleDeleteOutlet = (e, value, values, setFieldValue) => {
    e.stopPropagation();

    const updatedOutlets = values?.manager?.filter(
      (outlet) => outlet.value !== value
    );

    setFieldValue("manager", updatedOutlets);
  };

  return (
    <>
      <div className="model" onClick={onClose} style={{ zIndex: 1300 }}>
        <div
          className="bg-white items-center justify-center drop-shadow-lg rounded-lg w-full max-w-xl py-8 px-6 mx-auto relative"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <h4 className="font-Montserrat text-[34px] font-normal">
            {managerData ? "Edit Manager" : "Add Manager"}
          </h4>
          {isLoading ? (
            <RippleLoader />
          ) : (
            <Formik
              initialValues={{
                manager: managerData?.length
                  ? managerData.map((item) => ({
                      label: item.user.full_name || "",
                      value: item.user_id || "",
                    }))
                  : [],
              }}
              validationSchema={Yup.object().shape({})}
              onSubmit={(values) => {
                setFormValues(values);
              }}
            >
              {({
                values,
                handleSubmit,
                setFieldValue,
                errors,
                touched,
                validateForm,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <>
                    <div className="mb-4 mt-3">
                      <SelectWithLabel
                        idFromName="manager"
                        placeholder="Manager"
                        options={managerOptions}
                        value={
                          values?.manager?.map((option) => option.value) || []
                        }
                        setFieldValue={setFieldValue}
                        multiple
                        errors={errors.manager}
                        touched={touched.manager}
                        onChange={(event) => {
                          const selectedValues = event.target.value;
                          const selectedOptions = managerOptions?.filter(
                            (option) => selectedValues.includes(option.value)
                          );
                          setFieldValue("manager", selectedOptions);
                        }}
                        renderValue={(selected) => (
                          <>
                            {selected.map((value) => {
                              const selectedOption = managerOptions?.find(
                                (option) => option.value === value
                              );
                              return (
                                <Chip
                                  key={value}
                                  label={selectedOption?.label}
                                  sx={{ marginRight: "5px" }}
                                  clickable
                                  variant="outlined"
                                  deleteIcon={
                                    <Cancel
                                      onMouseDown={(event) =>
                                        event.stopPropagation()
                                      }
                                    />
                                  }
                                  onDelete={(e) =>
                                    handleDeleteOutlet(
                                      e,
                                      value,
                                      values,
                                      setFieldValue
                                    )
                                  }
                                />
                              );
                            })}
                          </>
                        )}
                      />
                      {/* <SelectWithLabel
                        idFromName="companyName"
                        placeholder="Company Name*"
                        options={companyOptions}
                        value={values?.companyName?.value || ""}
                        setFieldValue={setFieldValue}
                        errors={errors.companyName}
                        touched={touched.companyName}
                        endAdornment={
                          values?.companyName ? (
                            <IconButton
                              sx={{ position: "relative", right: "10px" }}
                              onClick={() => {
                                setFieldValue("companyName", "");
                                setFieldValue("customerFullName", "");
                                setFieldValue("outlet", []);
                                setCustomerOptions([]);
                                setOutletOptions([]);
                              }}
                            >
                              <ClearIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                          ) : null
                        }
                        onChange={(event) => {
                          setReinitialize(false);
                          const selectedOption = companyOptions?.find(
                            (option) => option.value === event.target.value
                          );

                          if (!selectedOption) return;

                          setFieldValue("companyName", selectedOption);
                          setFieldValue("customerFullName", "");
                          setFieldValue("outlet", []);
                          setCustomerOptions([]);
                          setOutletOptions([]);
                          setTouched({
                            ...touched,
                            companyName: false,
                            customerFullName: false,
                          });
                          handleCompanyChange(selectedOption?.value);
                        }}
                      /> */}
                    </div>
                  </>
                  {/* Submit button */}
                  <div className="flex justify-end gap-3 mt-3 w-full">
                    <button
                      onClick={onClose}
                      type="button"
                      className=" text-themeBtn w-full flex items-center uppercase font-Montserrat justify-center px-6 py-1.5 rounded border border-themeBtn"
                    >
                      <span>Cancel</span>
                    </button>
                    <button
                      type="button"
                      onClick={async () => {
                        const errors = await validateForm();

                        const isValid = Object.keys(errors).length === 0;

                        if (isValid) {
                          setFormValues(values);
                          setShowConfirmationModal(true);
                        }
                      }}
                      className={`${
                        values?.salesPerson?.length === 0
                          ? "cursor-not-allowed bg-borderLine text-textSecondary"
                          : "bg-themeBtn text-white"
                      } flex items-center w-full justify-center px-6 py-1.5 rounded font-Montserrat uppercase`}
                    >
                      <span>Confirm</span>
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </div>

        {/* Confirmation modals */}
        {showConfirmationModal && (
          <ConfirmationModel
            confirmText={managerData ? "Edit" : "Create"}
            onClose={() => setShowConfirmationModal(false)}
            onConfirm={() => handleFormSubmit(formValues)}
            isLoading={isLoading}
          />
        )}
      </div>
    </>
  );
};

export default AddEditManager;
